enum ProgramEvents {

    //プログラム一覧取得
    GetLearningProgramStarted = "[ProgramEvents] GetLearningProgramStarted",
    GetLearningProgramComplete = "[ProgramEvents] GetLearningProgramComplete",
    AddVideoToProgram = "[ProgramEvents] AddVideoToProgram",
    AddVideoToProgramComplete = "[ProgramEvents] AddVideoToProgramComplete",

    // プログラム一覧取得（プログラム管理用）
    GetAllProgramStarted =  "[ProgramEvents] GetAllProgramStarted",
    GetAllProgramComplete = "[ProgramEvents] GetAllProgramComplete",

    // プログラム更新（プログラム管理用）
    UpdateProgramStarted =  "[ProgramEvents] UpdateProgramStarted",
    UpdateProgramComplete = "[ProgramEvents] UpdateProgramComplete",
    UpdateProgramFailed = "[ProgramEvents] UpdateProgramFailed",
}
export default ProgramEvents;
